export default __webpack_public_path__ + "static/media/lifestyle.c3b1f011.png";